import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import InitiativeValidations from 'scaleflow/validators/initiative';
import { hideAll } from 'tippy.js';

export default class InitiativesInitiativeSummaryPanelComponent extends Component {
  initiativeValidations = InitiativeValidations;
  @service intl;
  @service initiativeSlideover;
  @service router;
  @service notifications;
  @service chatv2;
  @service betaToggle;

  tabs = [
    {
      label: this.intl.t('dictionary.details'),
      key: 'details',
    },
    {
      label: this.intl.t('dictionary.summary'),
      key: 'summary',
    },
    {
      label: this.intl.t('dictionary.activity'),
      key: 'activity',
    },
  ];

  @tracked tab = 'details';
  @tracked deleteConfirmationModalIsVisible = false;

  @action
  setTab(tab) {
    this.tab = tab;
  }

  @action
  deleteInitiative() {
    try {
      this.router.replaceWith('backlog.initiatives');
      this.args.initiative.destroyRecord();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  copyInitiativeLink() {
    navigator.clipboard.writeText(
      `${window.location.origin}/backlog/initiatives/${this.args.initiative.id}/description`,
    );
    this.notifications.toggleShowNotification(
      this.intl.t('_initiatives.initiative-link-copied', {
        initiative: this.intl.t('_initiatives.title', {
          num: 1,
        }),
      }),
    );
  }

  @action
  showActivityTabAndOpenUpdateWizard() {
    this.setTab('activity');
    this.initiativeSlideover.openWizard(this.args.initiative.id);
  }

  @action
  showDeleteConfirmationModal() {
    hideAll();
    this.deleteConfirmationModalIsVisible = true;
  }

  @action
  handleDeleteConfirmation() {
    this.deleteConfirmationModalIsVisible = false;
    this.deleteInitiative();
  }

  @action
  closeDeleteConfirmationModal() {
    this.deleteConfirmationModalIsVisible = false;
  }

  @action
  handleChatToggle() {
    this.chatv2.populateChatWindow();
    this.chatv2.toggleChatWindow();
  }
}
